import React from 'react';
import { XIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const notThese = ['Un altro manuale', 'Un altro corso online', 'Un’altra raccolta di linee guida cliniche'];
export function DifferenceSection() {
  return <section className="w-full bg-white" data-id="element-123" data-mp="3ija7hfnd7z75">
      <div className="mx-auto w-full max-w-3xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-124" data-mp="3nhli3slhidqf">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal" data-id="element-125" data-mp="3njpja2s00yn0">
          La differenza
        </p>
        <h2 className="mt-3 text-balance text-center font-display text-[30px] font-black leading-[1.1] tracking-[-0.02em] text-plum-deep sm:text-4xl" data-id="element-126" data-mp="2usnztph9wgxo">
          Cosa rende questo sistema diverso?
        </h2>

        <div className="mt-8 rounded-3xl bg-cream p-5 ring-1 ring-ink/5 sm:p-7" data-id="element-127" data-mp="34rn7p5u7s8jm">
          <p className="text-[13px] font-extrabold uppercase tracking-[0.14em] text-ink/45" data-id="element-128" data-mp="f2kzdp84whfd">
            Non è:
          </p>
          <ul className="mt-4 space-y-3" data-id="element-129" data-mp="k037jdebusmb">
            {notThese.map(item => <li key={item} className="flex items-start gap-3" data-id="element-130" data-mp="dehb4qwljf2w">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ink/10" data-id="element-131" data-mp="dbv2enxyytj3">
                  <XIcon className="h-3.5 w-3.5 text-ink/45" aria-hidden="true" data-id="element-132" data-mp="4dasocadzu70" />
                </span>
                <span className="text-[15.5px] leading-snug text-ink/60 line-through decoration-ink/25 sm:text-base" data-id="element-133" data-mp="3vkdjh2mbbygp">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="mt-6 rounded-3xl bg-plum-deep p-6 sm:p-8" data-id="element-134" data-mp="3lszmb1hu3aqq">
          <p className="text-[17px] font-semibold leading-relaxed text-white sm:text-xl" data-id="element-135" data-mp="3guodmu39z6a3">
            È un <span className="text-gold" data-id="element-136" data-mp="3ctmfkgl3h09p">sistema completo per il processo decisionale
            clinico</span>, progettato per aiutarti a gestire con sicurezza le pazienti in
            menopausa dalla valutazione iniziale fino al follow-up a lungo termine.
          </p>
          <p className="mt-5 text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-137" data-mp="32x9jxd5zoccb">
            Ogni raccomandazione segue le evidenze più aggiornate. Ogni algoritmo risponde alla
            domanda:
          </p>
          <p className="mt-3 font-display text-2xl font-black leading-tight text-white sm:text-3xl" data-id="element-138" data-mp="2j9ejiq7xb5lb">
            “Cosa devo fare adesso?”
          </p>
        </div>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-139" data-mp="2o8q2m5vrin62">
          <CTAButton label="Voglio il sistema completo per decidere" sub="6 volumi + 5 bonus • Solo 19 € oggi" variant="teal" data-id="element-140" data-mp="3bxipzdybjmp2" />
        </div>
      </div>
    </section>;
}